import { database } from "../firebase";
import SmartCache from "../indexeddb";
import createDoc from "./create_doc";
import { DateFromUnsafe } from "./util_functions";

/**
 * Pega todos os imóveis da empresa baseados no último imóvel editado, sempre vai pegar no mínimo 1 imóvel
 * 
 * @param {string} empresa 
 */
const syncImoveis = async (empresa:string, sab?: SharedArrayBuffer, categoria?: 'locacao'|'venda'):Promise<number> => {
    let counter: number = 0;
    try {
        console.log('SYNC MANUAL IMOVEIS')
        const ultimo_imovel_editado = await SmartCache.imoveis.getByLastDate('edited_at');

        if (ultimo_imovel_editado) {
            console.time('syncimoveisget')
            let imoveis_atualizados = database.collection(`empresas/${empresa}/imoveis`)

            // if (categoria) {
            //     if (categoria === 'locacao') {
            //         // @ts-ignore
            //         imoveis_atualizados = imoveis_atualizados.where('venda', '!=', true)
            //         // @ts-ignore
            //         imoveis_atualizados = imoveis_atualizados.orderBy('venda', 'asc')
            //     } else if (categoria === 'venda') {
            //         // @ts-ignore
            //         imoveis_atualizados = imoveis_atualizados.where('venda', '==', true)
            //         // @ts-ignore
            //         imoveis_atualizados = imoveis_atualizados.orderBy('venda', 'asc')
            //     }
            // }
            
            const imoveis_atualizados_get = await imoveis_atualizados.orderBy('edited_at','asc')
            .startAt(ultimo_imovel_editado.edited_at)
            .get();
            console.timeEnd('syncimoveisget')
            if (sab) {
                Atomics.add(new Uint32Array(sab), 1, imoveis_atualizados_get.size)
            }
            console.log({ultimo_imovel_editado}, imoveis_atualizados_get.docs.length)
            counter+=imoveis_atualizados_get.size;
            
            console.time('syncimoveisrest')
            const imoveis_atualizados_data = imoveis_atualizados_get.docs.map(createDoc)
            const imoveis = imoveis_atualizados_data.filter(imovel => imovel.edited_at)
            const imoveis_ids = imoveis.map(imovel => imovel.db_id)
            console.log(imoveis_ids)
            console.time('syncimoveisgetMultipleByIdMapReturn')
            const imoveis_no_cache = await SmartCache.imoveis.getMultipleByIdMapReturn(imoveis_ids)
            console.timeEnd('syncimoveisgetMultipleByIdMapReturn')
            const imoveis_pra_att:any[] = []
            for (const imovel of imoveis) {
                const imovel_cache = imoveis_no_cache.get(imovel.db_id)
                // Caso não esteja no cache, ou seja, imovel novo 
                if (!imovel_cache && imovel) {
                    imoveis_pra_att.push(imovel)
                    continue;
                }
                if (!imovel_cache.edited_at || !imovel.edited_at) continue;
                if (DateFromUnsafe(imovel_cache.edited_at).getTime() !== DateFromUnsafe(imovel.edited_at).getTime()) {
                    imoveis_pra_att.push(imovel)
                }
            }
            console.timeEnd('syncimoveisrest')
            console.log('Imóveis diff', imoveis_pra_att)
            if (imoveis_pra_att.length) {
                await SmartCache.imoveis.addMultiple(imoveis_pra_att)
            }
        }
    } catch (error) {
        console.log('sync imoveis outer', error)
    }
    
    return counter
}

export default syncImoveis